import init from '../../helpers/init';

const {$} = init;
const BX = (<any>window).BX;

$(() => {
  $(document).on('change', 'form.js-action-change select', function(){
    let formParent = $(this).parents('form');
    formParent.submit();
  });
});
